import { acceptedlanguages } from 'src/constants';

export const isAscii = (str: string) => /^[\x00-\x7F]*$/.test(str);
export const getLangCode = (lang: string | undefined | null) => {
    const langCode = lang?.slice(0, 2).toLowerCase() ?? '';
    return acceptedlanguages.includes(langCode) ? langCode : '';
};
